
// 报表下载按钮
export function downloadReportExcel(url) {
  let link = document.createElement('a');
  link.style.display = 'none';
  link.download='';
  link.href = url;
  document.body.appendChild(link);
  link.click();
  //下载完成后
  document.body.removeChild(link);
}

export default downloadReportExcel
